<script setup lang="ts">
type Props = {
  text?: string;
  disabled?: boolean;
};

withDefaults(defineProps<Props>(), {
  text: "",
  disabled: false,
});
</script>

<template>
  <h1
    v-if="!disabled && text"
    class="font-medium text-slate-700 dark:text-slate-200"
  >
    {{ text }}
  </h1>
</template>
